/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CustomComponentLibrariesLibraryIdGet200ResponseData } from './CustomComponentLibrariesLibraryIdGet200ResponseData';
import {
    CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON,
    CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSONTyped,
    CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON,
} from './CustomComponentLibrariesLibraryIdGet200ResponseData';

/**
 * 
 * @export
 * @interface CustomComponentLibrariesLibraryIdGet200Response
 */
export interface CustomComponentLibrariesLibraryIdGet200Response {
    /**
     * API request succeeded
     * @type {boolean}
     * @memberof CustomComponentLibrariesLibraryIdGet200Response
     */
    success: boolean;
    /**
     * 
     * @type {CustomComponentLibrariesLibraryIdGet200ResponseData}
     * @memberof CustomComponentLibrariesLibraryIdGet200Response
     */
    data: CustomComponentLibrariesLibraryIdGet200ResponseData;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdGet200Response interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdGet200ResponseFromJSON(json: any): CustomComponentLibrariesLibraryIdGet200Response {
    return CustomComponentLibrariesLibraryIdGet200ResponseFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'data': CustomComponentLibrariesLibraryIdGet200ResponseDataFromJSON(json['data']),
    };
}

export function CustomComponentLibrariesLibraryIdGet200ResponseToJSON(value?: CustomComponentLibrariesLibraryIdGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'data': CustomComponentLibrariesLibraryIdGet200ResponseDataToJSON(value.data),
    };
}

